import { render, staticRenderFns } from "./LearnStatisticsDialog.vue?vue&type=template&id=652f5a4b&scoped=true&"
import script from "./LearnStatisticsDialog.vue?vue&type=script&lang=js&"
export * from "./LearnStatisticsDialog.vue?vue&type=script&lang=js&"
import style0 from "./LearnStatisticsDialog.vue?vue&type=style&index=0&id=652f5a4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652f5a4b",
  null
  
)

component.options.__file = "LearnStatisticsDialog.vue"
export default component.exports